import { MarkerType } from 'reactflow';
import { EdgeStyle, EdgeMarkerEnd, EdgeProps } from 'pages/FlowBuilder/types/flow-builder.types';

const blues = {
  '200': '#7CB4FF',
  '700': '#182587',
};

const edgeStyle: EdgeStyle = {
  stroke: blues['200'],
  strokeWidth: 3,
};
const dashedEdgeStyle: EdgeStyle = {
  stroke: blues['200'],
  strokeWidth: 2,
  strokeDasharray: '5 5',
};

export const edgeMarkerEnd: EdgeMarkerEnd = {
  type: MarkerType.Arrow,
  width: 20,
  height: 20,
  color: blues['200'],
};

export const edgeProps: Partial<EdgeProps> = {
  type: 'default',
  style: edgeStyle,
  markerEnd: edgeMarkerEnd,
};

export const dashedEdgeProps: Partial<EdgeProps> = {
  type: 'default',
  style: dashedEdgeStyle,
  markerEnd: edgeMarkerEnd,
};

export const startEdgeProps: Partial<EdgeProps> = {
  ...dashedEdgeProps,
  style: { ...dashedEdgeStyle, strokeWidth: 3 },
  animated: true,
};

const neutralColor200 = '#CDD0D7';

export const defaultTargetHandleStyle: React.CSSProperties = {
  visibility: 'hidden',
};

export const defaultSourceHandleStyle: React.CSSProperties = {
  bottom: '-9px',
  width: '30px',
  height: '8px',
  border: 0,
  borderRadius: '0 0 30px 30px',
  backgroundColor: neutralColor200,
};

/**
 * ELK option maps for Flow Builder. Default `layered` matches journey DAGs; tweak here only.
 * `mrtree` kept for QA/rollback. React Flow ignores ELK bend points (Bezier handles only), so
 * placement drives clearance. LINEAR_SEGMENTS (not BRANDES_KOEPF) co-aligns TA→dummy→Content long
 * edges and centers TA over true siblings; `nodeNode` is horizontal clearance from that axis.
 */
export const FLOW_BUILDER_ELK_LAYERED_OPTIONS: Record<string, string> = {
  'elk.algorithm': 'layered',
  'elk.direction': 'DOWN',

  'elk.layered.spacing.nodeNodeBetweenLayers': '150',

  // Same-layer horizontal gap; with LINEAR_SEGMENTS, clearance from long-edge axis to bypass nodes.
  'elk.spacing.nodeNode': '100',

  // Orthogonal routing only (unused by React Flow edge drawing).
  'elk.spacing.edgeNode': '80',
  'elk.spacing.edgeEdge': '40',
  'elk.layered.spacing.edgeNodeBetweenLayers': '80',

  'elk.layered.nodePlacement.strategy': 'LINEAR_SEGMENTS',
  'elk.layered.crossingMinimization.strategy': 'LAYER_SWEEP',
  'elk.layered.considerModelOrder.strategy': 'NODES_AND_EDGES',
};

export const FLOW_BUILDER_ELK_MRTREE_OPTIONS: Record<string, string> = {
  'elk.algorithm': 'mrtree',
  'elk.spacing.nodeNode': '150',
};

export type FlowBuilderElkAlgorithm = 'layered' | 'mrtree';

export const DEFAULT_FLOW_BUILDER_ELK_ALGORITHM: FlowBuilderElkAlgorithm = 'layered';
